import env from '@beam-australia/react-env';

export const testID = (id: string) =>
    env('ENVIRONMENT') !== 'prod' ? { 'data-testid': id } : {};
